import { render, staticRenderFns } from "./appNotification.vue?vue&type=template&id=1bde3508&scoped=true&"
import script from "./appNotification.vue?vue&type=script&lang=js&"
export * from "./appNotification.vue?vue&type=script&lang=js&"
import style0 from "./appNotification.vue?vue&type=style&index=0&id=1bde3508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde3508",
  null
  
)

export default component.exports